export enum QueryKeys {
  FEATURE_FLAGS = 'feature_flags',
  RESOURCE_CONTEXT = 'resource_context',
  ENVIRONMENT_FEATURES = 'env_features',
  LOGGED_IN_MEMBER_DETAILS = 'logged_in_member_details',
  CURRENT_WORKSPACE_DETAILS = 'current_workspace_details',
  WORKSPACE_ENVIRONMENTS_LIST = 'workspace_environmets_list',
  OAUTH_TOKENS = 'oauth_tokens',
  ORGANIZATIONS = 'organizations',
  USERS = 'users',
  ORGANIZATIONS_SEARCH = 'organizations_search',
  CONNECTIONS = 'connections',
  DIRECTORIES = 'directories',
  ORGANIZATION_EVENTS = 'organization_events',
  DIRECTORY_USERS = 'directory_users',
  DIRECTORY_GROUPS = 'directory_groups',
  DIRECTORY_GROUPS_FROM_GBRA = 'directory_groups_gbra',
  CLIENT_CREDENTIALS = 'client_credentials',
  CLIENT_INCLUDE_PLAIN_SECRET = 'client_include_plain_secret',
  MEMBERS_LIST = 'members_list',
  INVITE = 'invite',
  DOMAINS = 'domains',
  PORTAL_SESSION = 'portal_session',
  PORTAL_SESSION_DETAILS = 'portal_session_details',
  USER_PROFILE_ATTRIBUTES = 'user_profile_attributes',
  PORTAL_CUSTOMIZATIONS = 'portal_customizations',
  SOCIAL_CONNECTIONS = 'social_connections',
  ENVIRONMENT_CONNECTIONS = 'environment_connections',
  SOCIAL_CONNECTION_DETAILS = 'social_connection_details',
  ENVIRONMENT_SSO_CONNECTIONS = 'environment_sso_connections',
  ACTIVE_SSO_CONNECTIONS = 'active_sso_connections',
  CONNECTION_DETAILS = 'connection_details',
  ENVIRONMENT_WEBHOOK_PORTAL_LINK = 'webhook_portal_link',
  ENVIRONMENT_ROLES = 'env_roles',
  ENVIRONMENT_PERMISSIONS = 'env_permissions',
  ORGANIZATION_ROLES = 'org_roles',
  ORGANIZATION_USER_MANAGEMENT_SETTINGS = 'org_user_management_settings',
  WORKSPACE_SUBSCRIPTIONS = 'workspace_subscriptions',
  WORKSPACE_PRICING_TABLE = 'workspace_pricing_table',
  WORKSPACE_BILLING_CUSTOMER_PORTAL = 'workspace_customer_portal',
  WORKSPACE_BILLING_USAGE = 'workspace_billing_usage',
  ENVIRONMENT_WEBHOOK_ENDPOINTS = 'environment_webhook_endpoints',
  ENVIRONMENT_WEBHOOK_EVENT_TYPES = 'environment_webhook_event_types',
  ENVIRONMENT_WEBHOOK_ENDPOINT_MESSAGES = 'environment_webhook_endpoint_messages',
  ENVIRONMENT_WEBHOOK_ENDPOINT_DELIVERY_ATTEMPT = 'environement_webhook_endpoint_delivery_attempt',
  CUSTOM_DOMAIN_GET_DNS_RECORDS = 'custom_domain_get_dns',
  DIRECTORY_GROUPS_SUMMARY_LIST = 'directory_groups_summary_list',
  EXTERNAL_DIRECTORY_GROUPS_LIST = 'external_directory_groups_list',
  ENVIRONMENT_SESSION_SETTINGS = 'environment_session_settings',
  ENV_EMAIL_CONFIGURATION = 'environment_email_config',
  HOSTED_AUTH_CUSTOMIZATIONS = 'hosted_auth_customizations',
  ENV_AUTH_METHODS_QUERY = 'environment_auth_methods',
  ORG_SWITCHER_ORGANIZATION_QUERY = 'org_switcher_organization_mapping',
  ORG_AUTH_FEATURES_QUERY = 'org_auth_features',
  AUTH_ERROR_QUERY = 'auth_error',
  ACTIVE_AUTH_STATE_QUERY = 'active_auth_state',
  OAUTH_CONSENT_DETAILS = 'oauth_consent_details',
  USERS_DETAILS = 'users_details',
  USERS_SEARCH = 'users_search',
  USER_SESSIONS = 'user_sessions',
  ENVIRONMENT_USER_MANAGEMENT_SETTINGS = 'environment_user_management_settings',
  ENVIRONMENT_MCP_SERVERS = 'environment_mcp_servers',
  ENVIRONMENT_MCP_SERVER_DETAILS = 'environment_mcp_server_details',
  ENVIRONMENT_MCP_SERVER_CLIENTS = 'environment_mcp_server_clients',
  CONNECTED_APP_PROVIDERS = 'connected_apps_providers',
  CONNECTED_APPS = 'connected_apps',
  CONNECTED_ACCOUNTS = 'connected_accounts',
  CONNECTED_ACCOUNT_DETAILS = 'connected_account_details',
  CONNECTED_APPS_TOOLS_LIST = 'tools_list',
  AUTHENTICATION_LOGS = 'authentication_logs',
  AUTHENTICATION_LOGS_FILTER = 'authentication_logs_filter',
  AUTHENTICATION_LOG_REQUEST_EVENTS = 'authentication_log_request_events',
  RESOURCES_BULK_FETCH_QUERY = 'resources_bulk_fetch',
  EMAIL_TEMPLATE_USECASES = 'email_template_usecases',
  EMAIL_CUSTOM_TEMPLATES = 'email_custom_templates',
  WORKSPACE_BILLING_INFO = 'workspace_billing_info',
  WORKSPACE_BILLING_ADDONS = 'workspace_billing_addons',
  INTERCEPTORS = 'interceptors',
  INTERCEPTOR_DETAILS = 'interceptor_details',
  INTERCEPTOR_LOGS = 'interceptor_logs',
  INTERCEPTOR_SIGNING_SECRET = 'interceptor_signing_secret',
  PASSKEY_CREDENTIALS_LIST = 'passkey_credentials_list'
}

const getFeatureFlagsQueryKey = () => [QueryKeys.FEATURE_FLAGS];

const getResourceContextQueryKey = () => [QueryKeys.RESOURCE_CONTEXT];

const getEnvironmentFeaturesQueryKey = () => [QueryKeys.ENVIRONMENT_FEATURES];

const getCurrentLoggedInMemeberKey = () => [QueryKeys.LOGGED_IN_MEMBER_DETAILS];

const getCurrentWorkspaceKey = () => [QueryKeys.CURRENT_WORKSPACE_DETAILS];

const getTokensQueryKey = () => [QueryKeys.OAUTH_TOKENS];

const getOrganizationsKey = (invalidator?: string) =>
  invalidator
    ? [QueryKeys.ORGANIZATIONS, invalidator]
    : [QueryKeys.ORGANIZATIONS];

const getOrganizationsSearchKey = (query?: string) =>
  query
    ? [QueryKeys.ORGANIZATIONS_SEARCH, query]
    : [QueryKeys.ORGANIZATIONS_SEARCH];

const getOrganizationDetailsKey = (orgId: any) => [
  QueryKeys.ORGANIZATIONS,
  orgId
];

const getUsersQueryKey = (organizationId: string = '-') => [
  QueryKeys.USERS,
  organizationId
];

const getUsersDetailsQueryKey = (userId: string) => [
  QueryKeys.USERS_DETAILS,
  userId
];

const getUserSessionsQueryKey = (userId: string) => [
  QueryKeys.USER_SESSIONS,
  userId
];

const getUsersSearchQueryKey = (
  organizationId: string = '-',
  searchQuery?: string
) =>
  searchQuery
    ? [QueryKeys.USERS_SEARCH, organizationId, searchQuery]
    : [QueryKeys.USERS_SEARCH, organizationId];

const getConnectionsKey = () => [QueryKeys.CONNECTIONS];

const getClientCredentialsKey = (includeSecret: boolean = false) => [
  QueryKeys.CLIENT_CREDENTIALS,
  includeSecret ? QueryKeys.CLIENT_INCLUDE_PLAIN_SECRET : '-'
];

const getEnviornmentListsKey = () => [QueryKeys.WORKSPACE_ENVIRONMENTS_LIST];

const getMembersListKey = () => [QueryKeys.MEMBERS_LIST];

const getSubscriptionsQueryKey = () => [QueryKeys.WORKSPACE_SUBSCRIPTIONS];

const getPricingTableQueryKey = () => [QueryKeys.WORKSPACE_PRICING_TABLE];

const getCustomerPortalQueryKey = () => [
  QueryKeys.WORKSPACE_BILLING_CUSTOMER_PORTAL
];

const getBillingUsageQueryKey = () => [QueryKeys.WORKSPACE_BILLING_USAGE];

const getOrganizationsConnectionKey = (orgId: any) => [
  QueryKeys.ORGANIZATIONS,
  orgId,
  QueryKeys.CONNECTIONS
];

const getOrganizationsConnectionDetailsKey = (orgId: any, connId: any) => [
  ...getOrganizationsConnectionKey(orgId),
  connId
];

const getOrganizationDirectoriesListQueryKey = (orgId: any) => [
  QueryKeys.ORGANIZATIONS,
  orgId,
  QueryKeys.DIRECTORIES
];

const getOrganizationEventsQueryKey = (directoryId: string) => [
  QueryKeys.ORGANIZATION_EVENTS,
  directoryId
];

const getDirectoryUsersQueryKey = (directoryId: string, pageToken?: string) => {
  const keys = [QueryKeys.DIRECTORY_USERS, directoryId];
  pageToken && keys.push(pageToken);
  return keys;
};

const getDirectoryGroupUsersQueryKey = (
  directoryId: string,
  groupId: string,
  pageToken?
) => {
  const keys = [QueryKeys.DIRECTORY_USERS, directoryId, groupId];
  pageToken && keys.push(pageToken);
  return keys;
};

const getDirectoryGroupsQueryKey = (
  directoryId: string,
  isFromGbra = false
) => [
  isFromGbra
    ? QueryKeys.DIRECTORY_GROUPS_FROM_GBRA
    : QueryKeys.DIRECTORY_GROUPS,
  directoryId
];

const getOrganizationsDirectoryDetailsQueryKey = (
  orgId: any,
  directoryId: any
) => [...getOrganizationDirectoriesListQueryKey(orgId), directoryId];

const getOrganizationsInviteKey = (orgId: any) => [
  ...getOrganizationDetailsKey(orgId),
  QueryKeys.INVITE
];

const getOrganizationsDomainsKey = (orgId: any) => [
  ...getOrganizationDetailsKey(orgId),
  QueryKeys.DOMAINS
];

const getPortalSessionQuery = () => [QueryKeys.PORTAL_SESSION];

const getPortalSessionDetailsQuery = () => [QueryKeys.PORTAL_SESSION_DETAILS];

const getPortalCustomizationConfigQuery = () => [
  QueryKeys.PORTAL_CUSTOMIZATIONS
];

const getPortalCustomizationConfigForEnvironmentQuery = (envId: string) => [
  QueryKeys.PORTAL_CUSTOMIZATIONS,
  envId
];

const getUserProfileAttributesQuery = () => [QueryKeys.USER_PROFILE_ATTRIBUTES];

const getConnectionListQuery = () => [QueryKeys.SOCIAL_CONNECTIONS];

const getEnvSsoConnectionListQueryKey = () => [
  QueryKeys.ENVIRONMENT_SSO_CONNECTIONS
];

const getEnvActiveSsoConnectionListQueryKey = (envId?: string) => [
  QueryKeys.ACTIVE_SSO_CONNECTIONS,
  envId ?? '-'
];

const getConnectionDetailsQuery = (connectionId?: string) => {
  const query: Array<string | QueryKeys> = [QueryKeys.CONNECTION_DETAILS];
  connectionId && query.push(connectionId);
  return query;
};

const getEnvironmentConnectionListQueryKey = (envId: string) => [
  QueryKeys.ENVIRONMENT_CONNECTIONS,
  envId
];

const getEnvironmentWebhookPortalQueryKey = () => [
  QueryKeys.ENVIRONMENT_WEBHOOK_PORTAL_LINK
];

const getEnvironmentRolesQueryKey = (environmentId?: string) => [
  QueryKeys.ENVIRONMENT_ROLES,
  environmentId ?? '-'
];

const getEnvironmentRoleDetailsQueryKey = (roleName: string) => [
  QueryKeys.ENVIRONMENT_ROLES,
  roleName
];

const getEnvironmentPermissionsListQueryKey = (environmentId?: string) => [
  QueryKeys.ENVIRONMENT_PERMISSIONS,
  environmentId ?? '-'
];

const getOrganizationRolesQueryKey = (organizationId?: string) => [
  QueryKeys.ORGANIZATION_ROLES,
  organizationId ?? '-'
];

const getOrganizationRoleDetailsQueryKey = (roleName: string) => [
  QueryKeys.ORGANIZATION_ROLES,
  roleName
];

const getOrgUserManagementSettingsQueryKey = (organizationId?: string) => [
  QueryKeys.ORGANIZATION_USER_MANAGEMENT_SETTINGS,
  organizationId ?? '-'
];

const getWebhookEndpointsQueryKey = (invalidator?: string) =>
  invalidator
    ? [QueryKeys.ENVIRONMENT_WEBHOOK_ENDPOINTS, invalidator]
    : [QueryKeys.ENVIRONMENT_WEBHOOK_ENDPOINTS];

const getWebhookEndpointDetailsQueryKey = (id) => [
  QueryKeys.ENVIRONMENT_WEBHOOK_ENDPOINTS,
  id
];

const getWebhookEndpointMessagesQueryKey = (id: string) => [
  QueryKeys.ENVIRONMENT_WEBHOOK_ENDPOINT_MESSAGES,
  id ?? '-'
];

const getWebhookEndpointDeliveryAttemptQueryKey = (id: string | null) => [
  QueryKeys.ENVIRONMENT_WEBHOOK_ENDPOINT_DELIVERY_ATTEMPT,
  id ?? '-'
];

const getWebhookEventTypesQueryKey = (invalidator?: string) =>
  invalidator
    ? [QueryKeys.ENVIRONMENT_WEBHOOK_EVENT_TYPES, invalidator]
    : [QueryKeys.ENVIRONMENT_WEBHOOK_EVENT_TYPES];

const getCustomDomainDnsRecordsQueryKey = (
  environmentId: string,
  customDomain: string
) => [QueryKeys.CUSTOM_DOMAIN_GET_DNS_RECORDS, environmentId, customDomain];

const getDirectoryGroupsSummaryListQueryKey = (dirId?: string) =>
  dirId
    ? [QueryKeys.DIRECTORY_GROUPS_SUMMARY_LIST, dirId]
    : [QueryKeys.DIRECTORY_GROUPS_SUMMARY_LIST];

const getExternalDirectoryGroupsListQueryKey = (dirId?: string) =>
  dirId
    ? [QueryKeys.EXTERNAL_DIRECTORY_GROUPS_LIST, dirId]
    : [QueryKeys.EXTERNAL_DIRECTORY_GROUPS_LIST];

const getEnvironmentSessionSettingsQueryKey = (environmentId: string) => [
  QueryKeys.ENVIRONMENT_SESSION_SETTINGS,
  environmentId ?? '-'
];

const getEnvironmentEmailConfigQueryKey = () => [
  QueryKeys.ENV_EMAIL_CONFIGURATION
];

const getEnvironmentEmailTemplateUsecasesQueryKey = () => [
  QueryKeys.EMAIL_TEMPLATE_USECASES
];

const getEnvironmentCustomTemplatesQueryKey = () => [
  QueryKeys.EMAIL_CUSTOM_TEMPLATES
];

const getHostedAuthPageCustomizationQueryKey = () => [
  QueryKeys.HOSTED_AUTH_CUSTOMIZATIONS
];

const getAuthEnvAuthMethodsQueryKey = () => [QueryKeys.ENV_AUTH_METHODS_QUERY];

const getSwitcherOrganizationMappingQueryKey = () => [
  QueryKeys.ORG_SWITCHER_ORGANIZATION_QUERY
];

const getCurrentAuthStateQueryKey = () => [QueryKeys.ACTIVE_AUTH_STATE_QUERY];

const getOrganizationAuthFeaturesQueryKey = () => [
  QueryKeys.ORG_AUTH_FEATURES_QUERY
];

const getAuthErrorQueryKey = () => [QueryKeys.AUTH_ERROR_QUERY];

const getEnvironmentUserManagementSettingsQueryKey = (
  environmentId: string
) => [QueryKeys.ENVIRONMENT_USER_MANAGEMENT_SETTINGS, environmentId ?? '-'];

const getOauthConsentDetailsQueryKey = () => [QueryKeys.OAUTH_CONSENT_DETAILS];

const getEnvironmentMcpServersListQueryKey = (environmentId?: string) => [
  QueryKeys.ENVIRONMENT_MCP_SERVERS,
  environmentId ?? '-'
];

const getMcpServerDetailsQueryKey = (serverId) => [
  QueryKeys.ENVIRONMENT_MCP_SERVER_DETAILS,
  serverId
];

const getMcpServerClientsListQueryKey = (serverId) => [
  QueryKeys.ENVIRONMENT_MCP_SERVER_CLIENTS,
  serverId
];

const getConnectedAppProvidersQueryKey = () => [
  QueryKeys.CONNECTED_APP_PROVIDERS
];

const getConnectedAppsListQueryKey = (invalidator?: string) =>
  invalidator
    ? [QueryKeys.CONNECTED_APPS, invalidator]
    : [QueryKeys.CONNECTED_APPS];

const getConnectedAppProviderByConnectionIdQueryKey = (
  connectionId: string
) => [QueryKeys.CONNECTED_APP_PROVIDERS, connectionId];

const getConnectedAccountListQueryKey = (
  connector?: string,
  environmentId?: string
) => [QueryKeys.CONNECTED_ACCOUNTS, connector ?? '-', environmentId ?? '-'];

const getConnectedAccountDetailsQueryKey = ({
  connector,
  identifier
}: {
  connector: string;
  identifier: string;
}) => [QueryKeys.CONNECTED_ACCOUNT_DETAILS, connector, identifier];

const getConnectedAppToolsListQueryKey = (
  { provider, toolName }: { provider?: string; toolName?: string } = {
    provider: '-',
    toolName: '-'
  }
) => [QueryKeys.CONNECTED_APPS_TOOLS_LIST, provider, toolName];

const getAuthLogsQueryKey = (environmentId: string = '-') => [
  QueryKeys.AUTHENTICATION_LOGS,
  environmentId
];

const getAuthLogsFilterQueryKey = (environmentId: string = '-') => [
  QueryKeys.AUTHENTICATION_LOGS_FILTER,
  environmentId
];

const getAuthRequestResourcesQueryKey = (authRequestId: string = '-') => [
  QueryKeys.RESOURCES_BULK_FETCH_QUERY,
  authRequestId
];

const getAuthRequestEventsQueryKey = (authRequestId: string = '-') => [
  QueryKeys.AUTHENTICATION_LOG_REQUEST_EVENTS,
  authRequestId
];

const getBillingInfoQueryKey = () => [QueryKeys.WORKSPACE_BILLING_INFO];

const getBillingAddonsQueryKey = () => [QueryKeys.WORKSPACE_BILLING_ADDONS];

const getInterceptorsQueryKey = (environmentId: string = '-') => [
  QueryKeys.INTERCEPTORS,
  environmentId
];

const getInterceptorDetailsQueryKey = (interceptorId: string = '-') => [
  QueryKeys.INTERCEPTOR_DETAILS,
  interceptorId
];

const getInterceptorLogsQueryKey = (
  environmentId: string = '-',
  interceptorId: string
) => [QueryKeys.INTERCEPTOR_LOGS, environmentId, interceptorId];

const getInterceptorSigningSecretQueryKey = (secretId: string = '-') => [
  QueryKeys.INTERCEPTOR_SIGNING_SECRET,
  secretId
];

const getPasskeyCredentialsListQueryKey = (userId: string = '-') => [
  QueryKeys.PASSKEY_CREDENTIALS_LIST,
  userId
];

export {
  getFeatureFlagsQueryKey,
  getResourceContextQueryKey,
  getEnvironmentFeaturesQueryKey,
  getCurrentLoggedInMemeberKey,
  getCurrentWorkspaceKey,
  getTokensQueryKey,
  getOrganizationsKey,
  getOrganizationsSearchKey,
  getOrganizationDetailsKey,
  getUsersQueryKey,
  getUsersDetailsQueryKey,
  getConnectionsKey,
  getClientCredentialsKey,
  getEnviornmentListsKey,
  getMembersListKey,
  getSubscriptionsQueryKey,
  getPricingTableQueryKey,
  getCustomerPortalQueryKey,
  getBillingUsageQueryKey,
  getOrganizationsConnectionKey,
  getOrganizationsConnectionDetailsKey,
  getOrganizationDirectoriesListQueryKey,
  getOrganizationEventsQueryKey,
  getDirectoryUsersQueryKey,
  getDirectoryGroupUsersQueryKey,
  getDirectoryGroupsQueryKey,
  getOrganizationsDirectoryDetailsQueryKey,
  getOrganizationsInviteKey,
  getOrganizationsDomainsKey,
  getPortalSessionQuery,
  getPortalSessionDetailsQuery,
  getUserProfileAttributesQuery,
  getEnvironmentConnectionListQueryKey,
  getConnectionListQuery,
  getEnvSsoConnectionListQueryKey,
  getEnvActiveSsoConnectionListQueryKey,
  getConnectionDetailsQuery,
  getPortalCustomizationConfigQuery,
  getPortalCustomizationConfigForEnvironmentQuery,
  getEnvironmentWebhookPortalQueryKey,
  getEnvironmentRolesQueryKey,
  getEnvironmentRoleDetailsQueryKey,
  getEnvironmentPermissionsListQueryKey,
  getOrganizationRolesQueryKey,
  getOrganizationRoleDetailsQueryKey,
  getOrgUserManagementSettingsQueryKey,
  getWebhookEndpointsQueryKey,
  getWebhookEndpointDetailsQueryKey,
  getWebhookEndpointMessagesQueryKey,
  getWebhookEndpointDeliveryAttemptQueryKey,
  getWebhookEventTypesQueryKey,
  getCustomDomainDnsRecordsQueryKey,
  getDirectoryGroupsSummaryListQueryKey,
  getExternalDirectoryGroupsListQueryKey,
  getEnvironmentSessionSettingsQueryKey,
  getEnvironmentEmailConfigQueryKey,
  getHostedAuthPageCustomizationQueryKey,
  getAuthEnvAuthMethodsQueryKey,
  getSwitcherOrganizationMappingQueryKey,
  getCurrentAuthStateQueryKey,
  getOrganizationAuthFeaturesQueryKey,
  getAuthErrorQueryKey,
  getUsersSearchQueryKey,
  getUserSessionsQueryKey,
  getEnvironmentUserManagementSettingsQueryKey,
  getEnvironmentMcpServersListQueryKey,
  getMcpServerDetailsQueryKey,
  getOauthConsentDetailsQueryKey,
  getMcpServerClientsListQueryKey,
  getConnectedAppProvidersQueryKey,
  getConnectedAppsListQueryKey,
  getConnectedAppProviderByConnectionIdQueryKey,
  getConnectedAccountListQueryKey,
  getConnectedAccountDetailsQueryKey,
  getConnectedAppToolsListQueryKey,
  getAuthLogsQueryKey,
  getAuthLogsFilterQueryKey,
  getAuthRequestResourcesQueryKey,
  getAuthRequestEventsQueryKey,
  getEnvironmentEmailTemplateUsecasesQueryKey,
  getEnvironmentCustomTemplatesQueryKey,
  getBillingInfoQueryKey,
  getBillingAddonsQueryKey,
  getInterceptorsQueryKey,
  getInterceptorDetailsQueryKey,
  getInterceptorLogsQueryKey,
  getInterceptorSigningSecretQueryKey,
  getPasskeyCredentialsListQueryKey
};
